<template>
  <MarketplaceCard
    v-if="campDigitalConfig"
    v-model="campDigitalConfig.enabled"
    logo-alt="CAMP Digital"
    description="Expert digital marketing for home services. We boost your online presence, drive leads, and keep your call board full. Let us elevate your business!"
    learn-more-link="https://campdigital.com/sera-referral/"
    cy-selector="marketplaceCampDigital"
  >
    <template #logo>
      <div class="w-full">
        <CampDigitalLogo class="h-12" />
      </div>
    </template>
    <template #configure>
      <div>
        <div v-if="campDigitalConfig.enabled" class="link" @click="toggleModal">
          View & Copy API Key
        </div>
        <div v-else class="text-gray">View & Copy API Key</div>
      </div>
    </template>
    <template #modal>
      <div>
        <Modal
          v-if="modalOpen"
          title="CAMP Digital Configuration API Key"
          class-name="camp-digital-config-modal"
          @hide-modal="toggleModal"
        >
          <template #submit>
            <Button @click="handleCopy">
              <span
                ><span v-if="!copied">Copy API Key</span
                ><span v-else>Copied to clipboard</span></span
              >
            </Button>
          </template>
          <div class="d-flex flex-column">
            <TextField
              v-model="campDigitalConfig.api_key"
              :readonly="true"
              class="full-width"
              label="API Key"
              name="api_key"
              placeholder="API Key"
              :validation-errors="v$.$errors"
            />
          </div>
        </Modal>
      </div>
    </template>
  </MarketplaceCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";
import CampDigitalLogo from "@/images/camp_digital_logo.svg?component";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    TextField,
    CampDigitalLogo,
    Button
  },
  data() {
    return {
      modalOpen: false,
      copied: false,
      initialEnabledValueLoaded: false
    };
  },
  computed: {
    ...mapState(["campDigitalConfig"])
  },
  watch: {
    "campDigitalConfig.enabled": function (newValue, oldValue) {
      if (!this.initialEnabledValueLoaded) {
        this.initialEnabledValueLoaded = true;
        return;
      }

      if (newValue !== oldValue) {
        this.updateEnabled();
      }
    }
  },
  mounted() {
    this.fetchCampDigitalIntegrations();
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      campDigitalConfig: {
        api_key: { required, $autoDirty: true }
      }
    };
  },
  methods: {
    ...mapActions([
      "fetchCampDigitalIntegrations",
      "updateCampDigitalIntegrations"
    ]),
    handleSave() {
      this.v$.$validate().then((valid) => {
        if (valid) {
          this.updateCampDigitalIntegrations({
            campDigitalConfig: this.campDigitalConfig
          }).then(() => {
            window.notify.success("CAMP Digital settings saved!");
            this.toggleModal();
          });
        }
      });
    },
    updateEnabled() {
      const en = this.campDigitalConfig.enabled;
      this.updateCampDigitalIntegrations({
        campDigitalConfig: { enabled: en }
      }).then(() => {
        window.notify.success(`CAMP Digital ${en ? "enabled" : "disabled"}!`);
      });
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    handleCopy() {
      navigator.clipboard
        .writeText(this.campDigitalConfig.api_key)
        .then(() => (this.copied = true));
    }
  }
};
</script>
